import React from 'react';
import { connect } from 'react-redux';
import { Notification } from '@beef/ui-kit';
import PropTypes from 'prop-types';
import { getCheckAddressConnected, getConnectionStatusText } from "../../../../store/checkAddress/selectors";
var _ConnectionStatus = function _ConnectionStatus(_ref) {
  var children = _ref.children,
    className = _ref.className,
    variant = _ref.variant;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "components-ConnectionStatus"
  }, /*#__PURE__*/React.createElement(Notification, {
    text: children,
    variant: variant
  }));
};
_ConnectionStatus.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string
} : {};
export var ConnectionStatus = connect(function (state) {
  var isSuccess = getCheckAddressConnected(state);
  return {
    children: getConnectionStatusText(state),
    variant: isSuccess ? 'secondary' : 'primary'
  };
})(_ConnectionStatus);